export const headerMenu = [
  {
    url: '/internetMonitor',
    name: '产品与服务',
    child: [{
      name: '网络性能监控系统',
      link: '/internetMonitor'
    }, {
      name: '虚拟化监控系统',
      link: '/virtualMonitor'
    }, {
      name: '网络配置管理系统',
      link: '/configMonitor'
    }, {
      name: '混合云监控系统',
      link: '/cloundMonitor'
    }, {
      name: '服务器&应用监控系统',
      link: '/serviceMonitor'
    }, {
      name: '日志管理分析',
      link: '/log'
    }, {
      name: 'WEB应用性能监控系统',
      link: '/webMonitor'
    }, {
      name: '存储监控系统',
      link: '/storageMonitor'
    }, {
      name: '分布式轮询引擎',
      link: '/engineMonitor'
    }, {
      name: 'IP地址管理&终端用户追踪系统',
      link: '/ipMonitor'
    }, {
      name: '网络流量分析',
      link: '/network'
    }]
  },
  {
    url: '/operations_itsm',
    name: '运维管理',
    child: [{
      name: 'IT服务管理ITSM',
      link: '/operations_itsm'
    }, {
      name: '配置管理CMDB',
      link: '/operations_cmdb'
    }]
  },
  {
    url: '/resolution',
    name: '解决方案',
    child: [{
      name: '证券行业运维方案',
      link: '/resolution_case1'
    }]
  },
  // {
  //   url: '/support',
  //   name: '认证培训',
  //   child: [{
  //     name: 'Zabbix 初级认证 (ZCU)',
  //     link: '/train_zcu'
  //   },
  //   {
  //     name: 'Zabbix 中级认证 (ZCS)',
  //     link: '/train_zcs'
  //   },
  //   {
  //     name: 'Zabbix 高级认证 (ZCP)',
  //     link: '/train_zcp'
  //   },
  //   {
  //     name: 'Zabbix 专家级认证 (ZCE)',
  //     link: '/train_zce'
  //   }]
  // },
  {
    url: '/products',
    name: '技术支持'
  },
  {
    url: '/partners',
    name: '合作伙伴',
    child: [
      // {
      //   name: '合作伙伴级别',
      //   link: 'partnerLevel'
      // }, {
      //   name: '合作伙伴分布',
      //   link: 'partnerMap'
      // }
    // {
    //   name: '合作伙伴列表',
    //   link: 'partnerList'
    // }
    ]
  },
  {
    url: '/about',
    name: '关于我们',
    child: [{
      name: '企业动态',
      link: '/news',
      isPage: true
    },
    // {
    //   name: '公司介绍',
    //   link: 'introduce'
    // },
    // {
    //   name: '荣誉资质',
    //   link: 'honor',
    //   isPage: true
    // },
    {
      name: '联系我们',
      link: '/contact',
      isPage: true
    }]
  }
]

export const productsList = [{
  name: '网络性能监控系统',
  link: '/internetMonitor'
}, {
  name: '虚拟化监控系统',
  link: '/virtualMonitor'
}, {
  name: '网络配置管理系统',
  link: '/configMonitor'
}, {
  name: '存储监控系统',
  link: '/storageMonitor'
}, {
  name: '混合云监控系统',
  link: '/cloundMonitor'
}, {
  name: 'WEB应用性能监控系统',
  link: '/webMonitor'
}, {
  name: '服务器&应用监控系统',
  link: '/serviceMonitor'
}, {
  name: '分布式轮询引擎',
  link: '/engineMonitor'
}, {
  name: 'IP地址管理&终端用户追踪系统',
  link: '/ipMonitor'
}, {
  name: '日志管理分析',
  link: '/log'
}, {
  name: '网络流量分析',
  link: '/network'
}]

export const operationsList = [{
  name: 'IT服务管理ITSM',
  link: '/operations_itsm'
}, {
  name: '配置管理CMDB',
  link: '/operations_cmdb'
}]

export const resolutionList = [{
  name: '证券行业运维方案',
  link: '/resolution_case1'
}]

export const supportList = [{
  name: 'Zabbix 初级认证 (ZCU)',
  link: '/train_zcu'
},
{
  name: 'Zabbix 中级认证 (ZCS)',
  link: '/train_zcs'
},
{
  name: 'Zabbix 高级认证 (ZCP)',
  link: '/train_zcp'
},
{
  name: 'Zabbix 专家级认证 (ZCE)',
  link: '/train_zce'
}]

export const partnersList = [
  // {
  //   name: '合作伙伴级别',
  //   link: 'partnerLevel',
  //   linkM: 'partnerLevel-m'
  // }, {
  //   name: '合作伙伴分布',
  //   link: 'partnerMap',
  //   linkM: 'partnerMap-m'
  // }
  // {
  //   name: '合作伙伴列表',
  //   link: 'partnerList',
  //   linkM: 'partnerList-m'
  // }
]

export const aboutList = [
  {
    name: '企业动态',
    link: '/news',
    linkM: '/news',
    isPage: true
  },
  // {
  //   name: '公司介绍',
  //   link: 'introduce',
  //   linkM: 'introduce-m'
  // },
  // {
  //   name: '荣誉资质',
  //   link: 'honor',
  //   isPage: true
  // },
  {
    name: '联系我们',
    link: '/contact',
    linkM: '/contact',
    isPage: true
  }
]
